import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import PropertyDetailPage from './pages/PropertyDetailPage'

function App() {
  return (
    <Routes>
      <Route path="/homes" element={<HomePage />} />
      <Route path="/homes/:listingKey" element={<PropertyDetailPage />} />
      <Route path="/" element={<HomePage />} />
    </Routes>
  )
}

export default App
